import { Field } from "../index";

const generateFormQuestionPrompt = (
  userRequest: string,
  formName: string,
  formDescription: string,
  currentFields: Field[],
) => {
  const stringifiedFields = JSON.stringify(currentFields, null, 2);

  return `
### Input Details:
**Current Form Name**: ${formName || "Untitled Form"}

**Current Form Description**: ${formDescription || ""}

**User Request**:
\`\`\`
${userRequest}
\`\`\`

**Existing Fields**:
\`\`\`json
${stringifiedFields}
\`\`\`
`;
}

export default generateFormQuestionPrompt;